const translations = {
  "en": {
    "Couldn’t open Ed. Please try again.": "Couldn’t open Ed. Please try again."
  },
  "zh-tw": {
    "Couldn’t open Ed. Please try again.": "無法開啟 Ed 對話，請再試一次。"
  }
};

export default translations;
